import * as React from 'react';
import classNames from 'classnames';

import './logo.scss';

export type LogoProps = {
  color?: 'black' | 'white',
  style?: any,
  type?: 'link' | 'image'
};

const Logo = ({
  color = 'white',
  style = {},
  type = 'link'
}: LogoProps) => {
  const logoProps = {
    className: classNames({
      logo: true,
      [`logo--${color}`]: true
    }),
    style
  };

  if (type === 'link') {
    return (
      <a href="/" {...logoProps} />
    );
  }

  return (
    <div {...logoProps} />
  );
};

export default Logo;
